import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { CrudGenericsService } from '../common/crud-generics';
import { Environment, StrumentiMisura } from '../../models/-index';

@Injectable()
export class StrumentiMisuraService extends CrudGenericsService<StrumentiMisura, number> {
  // private base:string;;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/StrumentiMisura`);
    //  this.base = `${env.apiUrl}/api/StrumentiMisura/`;
  }
}
